// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ApiService {
   $broadcastTypes: any
   $http: any
   $q: any
   $rootScope: any
   $timeout: any
   $window: any
   endpoint: any
   fire: any
   previousApiRequest: any
   requestCanceler: any
   requestCompleted: any
   sessionHeader: any
   session_id: any
   storedQuery: any
   constructor($http: any, $rootScope: any, $q: any, $timeout: any, $broadcastTypes: any, $window: any, hooksService: any) {
      this.applyParams = this.applyParams.bind(this)
      this.get = this.get.bind(this)
      this.search = this.search.bind(this)
      this.documentDetail = this.documentDetail.bind(this)
      this.reviews = this.reviews.bind(this)
      this.aiDocuments = this.aiDocuments.bind(this)
      this.facetValues = this.facetValues.bind(this)
      this.contentTypes = this.contentTypes.bind(this)
      this.disciplines = this.disciplines.bind(this)
      this.languages = this.languages.bind(this)
      this.libraryLocations = this.libraryLocations.bind(this)
      this.databases = this.databases.bind(this)
      this.courseReserves = this.courseReserves.bind(this)
      this.cites = this.cites.bind(this)
      this.citedBy = this.citedBy.bind(this)
      this.relatedItems = this.relatedItems.bind(this)
      this.bulkExport = this.bulkExport.bind(this)
      this.$http = $http
      this.$rootScope = $rootScope
      this.$q = $q
      this.$timeout = $timeout
      this.$broadcastTypes = $broadcastTypes
      this.$window = $window
      this.session_id = null
      this.sessionHeader = "SUMMON-SID"
      this.endpoint = "/api"
      this.storedQuery = null
      this.previousApiRequest = null    // for API debugging

      hooksService.setHooks(this, 'ApiService', ['update'])
   }

   apiParamsFor(params: any) {
      const apiParams: object = {}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      apiParams['screen_res'] = `W${this.$window.innerWidth}H${this.$window.innerHeight}`
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      apiParams['__refererURL'] = decodeURIComponent(__refererURL)
      for (var k in params) {
         var v = params[k]
         var value = v === true ?
            't'
            : v === false ?
               'f'
               :
               angular.copy(v)
         // @ts-expect-error FIXME type inference
         if (_.isNumber(value) || (value?.length > 0)) { apiParams[k] = value }
      }
      return apiParams
   }

   applyParams(params: any) {
      let needle
      if ((needle = 'id', _.keys(params).includes(needle)) && params.id) {
         const detailParams = {q:`id:${params.id}`}
         delete params.id
         // NOTE: need to run search before retrieving document to avoid a race condition
         //   dealing with availabilities; we want RTA for results feed docs to be run
         //   before the RTA for the detail page single doc
         this.search(params)
         return this.documentDetail(detailParams)
      } else {
         return this.search(params)
      }
   }

   // avoidUpdateFire is to handle the request as Promise
   get(method: any, params: any, {debug = false, avoidUpdateFire = false, httpPost = false} = {}) {
      if (!debug) { this.previousApiRequest = { method, params } }
      const apiParams = this.apiParamsFor(params)
      let qs = $.param(apiParams)
      if (!!qs.length) { qs = `?${qs}` }
      if (debug) { qs = `${qs}&raw=true` }
      const headers = {}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (this.session_id) { headers[this.sessionHeader] = this.session_id }
      let msg = {types: []}

      if (method === "search") {
         // @ts-expect-error TS(2339) FIXME: Property 'q' does not exist on type '{}'.
         const currentQuery = apiParams.q
         if (currentQuery === this.storedQuery) {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.search)
         } else {
            this.storedQuery = currentQuery
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.newSearch)
         }
         this.$rootScope.$broadcast('apiRequest', msg)
      }
      if (method === "facet_values") {
         // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
         msg.types.push(this.$broadcastTypes.moreFacets)
         // allow time for DOM processing before firing request event
         // NOTES:
         //   only necessary for facet_values; clicking the 'more' facets button
         //   will force a scroll to top which we want to process first. otherwise,
         //   it scrolls back down to where the click occurred when the results
         //   arrive (as is the case when refinements are selected)
         this.$timeout(() => this.$rootScope.$broadcast('apiRequest', msg))
      }

      // cancel the previous 'search' request if it has not yet completed successfully;
      // 'facet_values' requests can be processed concurrently
      if ((method === "search") && this.requestCanceler && !this.requestCompleted) {
         this.requestCanceler.resolve()
         delete this.requestCanceler
      }

      const requestConfig = {headers}
      // NOTES:
      //   * requestCanceler/requestCompleted are properties of the service rather
      //     than that of the method so we can keep track of status for (and be able to
      //     cancel) the current request being processed; these need to be set AFTER
      //     checking to see if a request needs to be canceled.
      //   * add a request canceler only for 'search' requests; 'facet_values' requests
      //     can be processed concurrently
      this.requestCompleted = false
      if (method === "search") {
         this.requestCanceler = this.$q.defer()
         // @ts-expect-error TS(2339) FIXME: Property 'timeout' does not exist on type '{ heade... Remove this comment to see the full error message
         requestConfig.timeout = this.requestCanceler.promise
      }
      const startTime = Date.now()
      const promise = !httpPost ?
         this.$http.get(`${this.endpoint}/${method}${qs}`, requestConfig)
         :
         this.$http.post(`${this.endpoint}/${method}`, apiParams, requestConfig)

      const broadcastCompletion = (eventType: any, errObj = {}) => {
         let forceDelay
         msg = {
            types: [],
            // @ts-expect-error TS(2322) FIXME: Type '{ types: never[]; isPageRequest: boolean; er... Remove this comment to see the full error message
            isPageRequest: params.pn > 1,
            errorObject: errObj
         }
         if (method === 'search') {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.newSearch)
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.search)
         }
         if (method === 'facet_values') {
            forceDelay = true
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.moreFacets)
         }
         if (method === 'content_types') {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.contentTypes)
         }
         if (method === 'disciplines') {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.disciplines)
         }
         if (method === 'languages') {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.languages)
         }
         if (method === 'library') {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.library)
         }
         if (method === 'databases') {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parameter type
            msg.types.push(this.$broadcastTypes.databases)
         }
         if (['citations/cites', 'citations/citedby'].includes(method)) {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.citationTrail)
         }
         if (['reviews', 'ai_documents'].includes(method)) {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            msg.types.push(this.$broadcastTypes.other)
         }

         // only delay broadcast when necessary
         if (forceDelay) {
            return this.$timeout(() => this.$rootScope.$broadcast(eventType, msg))
         } else {
            return this.$rootScope.$broadcast(eventType, msg)
         }
      }

      const responseHandler = (response: any) => {
         if (!this.session_id) {
            this.session_id = response.headers()[this.sessionHeader.toLowerCase()]
         }
         response.data._elapsedTime = Date.now() - startTime
         if (!avoidUpdateFire) {
            this.fire('update', response.data, debug)
         }
         this.requestCompleted = true
         if (response.status === 500) {
            broadcastCompletion("apiError")
         } else {
            broadcastCompletion("apiSuccess")
         }
         return response
      }

      const responseErrorHandler = (response: any) => {
         const {
            status
         } = response
         let {
            data
         } = response
         // set a var to indicate that response is an http error (4xx, 5xx); 'data' in these cases can be empty
         const errorResponse = !!(status + '').match(/[45]\d{2}/)
         // an empty data param means that the request was cancelled
         if ((!data || (data === '')) && !errorResponse) {
            broadcastCompletion("apiCancel")
         } else {
            if (data || (status === 0)) { this.requestCompleted = true }
            // set the httpStatus code to the status returned from the server if 'data' is empty
            if ((!data || (data === '')) && (parseInt(status) !== 0)) { data = {httpStatus: parseInt(status)} }
            broadcastCompletion("apiError", data)
         }
         if (!avoidUpdateFire) { return response } else { throw response }
      }

      // handle response from API
      return promise
         .then(responseHandler)
         .catch(responseErrorHandler)
   }

   searchResearchAssistantDocument(params: any){
      const apiParams = this.apiParamsFor(params)
      let qs = $.param(apiParams)
      if (qs.length) { qs = `?${qs}`}
      const headers = {}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (this.session_id) { headers[this.sessionHeader] = this.session_id }

      if (this.requestCanceler && !this.requestCompleted) {
         this.requestCanceler.resolve()
         delete this.requestCanceler
      }

      const requestConfig = { headers }
      this.requestCompleted = false
      this.requestCanceler = this.$q.defer()
      // @ts-expect-error TS(2339) FIXME: Property 'timeout' does not exist on type '{ heade... Remove this comment to see the full error message
      requestConfig.timeout = this.requestCanceler.promise

      const startTime = Date.now()
      const promise = this.$http.get(`${this.endpoint}/search${qs}`, requestConfig) //document
      const responseHandler = (response: any) => {
         if (!this.session_id) {
            this.session_id = response.headers()[this.sessionHeader.toLowerCase()]
         }
         response.data._elapsedTime = Date.now() - startTime
         this.requestCompleted = true
         return response
      }

      const responseErrorHandler = (response: any) => {
         const { status } = response
         let { data } = response
         const errorResponse = !!(status + '').match(/[45]\d{2}/)
         if ((!data || (data === '')) && !errorResponse) {
            console.log("apiCancel")
         } else {
            if (data || (status === 0)) { this.requestCompleted = true }
            if ((!data || (data === '')) && (parseInt(status) !== 0)) { data = { httpStatus: parseInt(status) } }
            console.log("apiError", data)
         }
         return response
      }

      return promise
         .then(responseHandler)
         .catch(responseErrorHandler)
   }

   search(params: any) {
      return this.get('search', params)
   }

   documentDetail(params: any) {
      return this.get('document', params)
   }

   reviews(params: any) {
      return this.get('reviews', params)
   }

   aiDocuments(params: any) {
      return this.get('ai_documents', params)
   }

   facetValues(facet: any, params: any) {
      const apiParams = this.apiParamsFor(params)
      // @ts-expect-error TS(2339) FIXME: Property 'facet' does not exist on type '{}'.
      apiParams.facet = facet
      // @ts-expect-error TS(2339) FIXME: Property 'pn' does not exist on type '{}'.
      apiParams.pn = 1
      return this.get('facet_values', apiParams)
   }

   contentTypes() {
      return this.get('content_types', {})
   }

   disciplines() {
      return this.get('disciplines', {})
   }

   languages() {
      return this.get('languages', {})
   }

   libraryLocations() {
      return this.get('library', {})
   }

   databases(params: { ho: boolean, facet_page: number, facet_count: number }) {
      return this.get('databases', params, { avoidUpdateFire: true })
   }

   courseReserves(apiParams: any) {
      return this.get('search', apiParams, {avoidUpdateFire: true})
   }

   cites(apiParams: any) {
      return this.get('citations/cites', apiParams, {avoidUpdateFire: true})
   }

   citedBy(apiParams: any) {
      return this.get('citations/citedby', apiParams, {avoidUpdateFire: true})
   }

   relatedItems(apiParams: any) {
      return this.get('related_items', apiParams, {avoidUpdateFire: true, httpPost: true})
   }
   
   bulkExport(apiParams: any) {
      return this.get('bulk_export', apiParams, {avoidUpdateFire: true, httpPost: true})
   }
}

ApiService.$inject = ['$http', '$rootScope', '$q', '$timeout', '$broadcastTypes', '$window', 'hooksService']

angular.module('summonApp.services')
   .service('apiService', ApiService)
